exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".SideNavLayout-32a7027b{min-height:100vh;position:relative;max-width:1920px;min-width:375px}.SideNavLayout-32a7027b.notCollapsed-62f3d02c,.SideNavLayout-32a7027b.userCollapse-bb6ab824{display:flex}.sidebar-f85163b0{width:240px;box-shadow:0 1px 1px 0 rgba(0,0,0,0.08),0px 1px 6px 1px rgba(0,0,0,0.08);position:relative;z-index:2}.userCollapse-bb6ab824 .sidebar-f85163b0{width:60px;box-shadow:0 1px 1px 0 rgba(0,0,0,0.08),0px 1px 6px 1px rgba(0,0,0,0.08);position:relative;z-index:2}.viewportCollapse-2e3de157 .sidebar-f85163b0{width:100%}.content-49bb61a4{flex:1 1;min-width:0;z-index:1}\n", ""]);

// Exports
exports.locals = {
	"SideNavLayout": "SideNavLayout-32a7027b",
	"notCollapsed": "notCollapsed-62f3d02c",
	"userCollapse": "userCollapse-bb6ab824",
	"sidebar": "sidebar-f85163b0",
	"viewportCollapse": "viewportCollapse-2e3de157",
	"content": "content-49bb61a4"
};